import * as React from 'react';

export interface FilterDropdownMenuWrapperProps {
  onClick?: React.MouseEventHandler<any>;
  children?: any;
  className?: string;
  ecId:string;
}

export default (props: FilterDropdownMenuWrapperProps) => (
  <div className={props.className} onClick={props.onClick}>
    {props.children}
  </div>
);



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/view/view-table/FilterDropdownMenuWrapper.tsx